import React, { useState, useEffect, createRef } from 'react';
import { Select } from 'vivace-fluent-motion';
import IntlMessage from '../../helpers/intlMessage';

function SelectAsyncComponent(props) {
  const [option, setOption] = useState();
  const [inputValue, setInputValue] = useState('');
  const [innerRef, setInnerRef] = useState(createRef());

  useEffect(() => {
    if (props.innerRef !== undefined) {
      setInnerRef(props.innerRef);
    }
    if (props.value && props.value !== option) {
      setOption(props.value);
    }
  }, [props]);

  const handlerInput = (val) => {
    setInputValue(val);
  };

  const filteSelect = (value) => {
    if (value || props.first) {
      return props.options.filter((i) =>
        i.label.toLowerCase().includes(value.toLowerCase()),
      );
    }
  }

  const loadOptions = (value, callback) => {
    setTimeout(() => {
      callback(filteSelect(value));
    }, 1000);
  }

  function noOptionsMessage() {
    if (inputValue === '') {
      return <IntlMessage id = "dashboards.examDetail.performSearch"/>;
    } else {
      return <IntlMessage id = "dashboards.examDetail.noRecordFound"/>;
    }
  }

  return (
    <Select
      //isLoading={true}
      classNamePrefix={`mv-vivace-fluent-motion-select${props.isMulti ? '-multi' : ''
        }`}
      tabIndex={props.tabIndex}
      isDisabled={props.disabled}
      innerRef={innerRef}
      async={true}
      cacheOptions
      defaultOptions
      height={38}
      value={option}
      onChange={props.onChange}
      placeholder={!props.placeholder ? "escolha um " : props.placeholder}
      onInputChange={props.onInputChange ? props.onInputChange : handlerInput}
      loadOptions={props.loadOptions ? props.loadOptions : loadOptions}
      loadingMessage={() => <IntlMessage id = "message.loading"/>}
      noOptionsMessage={() => props.noOptionsMessage ? props.noOptionsMessage : noOptionsMessage()}
    />
  );
}


export default SelectAsyncComponent;



// WEBPACK FOOTER //
// ./src/componentes/select/select-async.component.js